export type BoxedRef<T extends Ref> = {
  ref: T;
  __v_skip: true;
  _isBoxedRef: true;
}

export const isBoxedRef = <T extends Ref>(x: any): x is BoxedRef<T> => {
  if (x === null || typeof x === 'undefined' || typeof x !== 'object') return false;
  return x._isBoxedRef === true; 
}

export const boxedRef = <T extends Ref>(x: T): BoxedRef<T> => {
  return {
    ref: x,
    __v_skip: true,
    _isBoxedRef: true
  }
}
